import { createContext } from "react";
import useCart from "../../../hooks/useCart";

const FormBuilderCartContext = createContext({
    formBuilderCart: [],
    newCartItems: [],
    addCartItems: () => {},
    removeCartItem: () => {},
    removeNewCartItems: () => {},
    clearCartItems: () => {},
});

export const FormBuilderCartProvider = ({ children }) => {
    const cartValue = useCart();

    return (
        <FormBuilderCartContext.Provider value={cartValue}>
            {children}
        </FormBuilderCartContext.Provider>
    );
}

export default FormBuilderCartContext;